import AurPopup from '../common/aur-popup/AurPopup';
import {t} from 'i18next';
import {POPUP_BUTTON_STYLE} from '../../constants/constants';

interface ILogoutPopupProps {
  modalIsOpen: boolean;
  closeModal: () => void;
  logOut: () => void;
  showLoading?: boolean;
}

export const LogoutPopup: React.FC<ILogoutPopupProps> = (props) => {
  const {modalIsOpen, closeModal, logOut, showLoading} = props;
  return (
    <>
      <AurPopup
        className="logout-popup-modal"
        open={modalIsOpen}
        onOk={logOut}
        onCancel={closeModal}
        showPopupHeading={true}
        buttonStyle={POPUP_BUTTON_STYLE.STACKED}
        popupHeading={t('common.logoutPopup.message')}
        labelActionCancel={t('common.logoutPopup.cancelBtn')}
        labelActionOk={t(
          `common.logoutPopup.${showLoading ? 'loggingOut' : 'okayBtn'}`
        )}
        actionOkLoader={showLoading}
        showActionOkWithLoader={true}
        actionOkLoaderClass="ok-action-loader"
        actionCancelDisable={showLoading}
      />
    </>
  );
};
